import { radioClasses } from '@mui/material/Radio';

import {
  RADIO_BORDER_CLASS,
  RADIO_CHECKED_ICON,
  RADIO_DOT_CLASS,
  RADIO_FILL_CLASS,
  RADIO_ICON,
  RADIO_ICON_CLASS,
} from 'theme/components/radio-icons';
import {
  SELECTION_CONTROL_ACTIVE_STATES,
  selectionControlHalo,
  selectionControlSizeVariants,
  selectorsWithin,
} from 'theme/components/selection-control';
import type { ComponentOverrides } from 'theme/theme.types';

const BORDER = `.${RADIO_BORDER_CLASS}`;
const FILL = `.${RADIO_FILL_CLASS}`;
const DOT = `.${RADIO_DOT_CLASS}`;
const CHECKED = `&.${radioClasses.checked}`;
const DISABLED = `&.${radioClasses.disabled}`;

export const MuiRadio: ComponentOverrides['MuiRadio'] = {
  defaultProps: {
    disableRipple: true,
    icon: RADIO_ICON,
    checkedIcon: RADIO_CHECKED_ICON,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      variants: selectionControlSizeVariants,
      ...selectionControlHalo(theme),
      [`& ${BORDER}`]: { color: theme.palette.tokens.navy[400] },
      [`& ${FILL}`]: { color: theme.palette.background.paper },
      [`& ${DOT}`]: { color: theme.palette.secondary.main },
      [selectorsWithin(SELECTION_CONTROL_ACTIVE_STATES, BORDER)]: {
        color: theme.palette.secondary.main,
      },
      [`${CHECKED} ${BORDER}`]: { color: theme.palette.secondary.main },
      [`${DISABLED} ${BORDER}`]: { color: theme.palette.action.disabledBorder },
      [`${DISABLED} ${FILL}`]: {
        color: theme.palette.action.disabledBackground,
      },
      [`${DISABLED} ${DOT}`]: { color: theme.palette.action.disabled },
      '@media (forced-colors: active)': {
        [`& .${RADIO_ICON_CLASS}`]: { forcedColorAdjust: 'none' },
        [`& ${BORDER}`]: { color: 'CanvasText' },
        [`& ${FILL}`]: { color: 'Canvas' },
        [`& ${DOT}`]: { color: 'Highlight' },
        [`${CHECKED} ${BORDER}`]: { color: 'Highlight' },
        [`${DISABLED} ${BORDER}`]: { color: 'GrayText' },
        [`${DISABLED} ${FILL}`]: { color: 'Canvas' },
        [`${DISABLED} ${DOT}`]: { color: 'GrayText' },
      },
    }),
  },
};
